import { render } from "./404.vue?vue&type=template&id=a100c38a&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=a100c38a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a100c38a"]])

export default __exports__